<template>
	<div>
		<app-header></app-header>
		<div class="mt-70">
			<v-container grid-list-xl pt-0>
				<v-layout row wrap>
					<v-flex xs12 md12 lg12 sm12 class="col-height-auto">
						<v-layout row wrap >
						<v-flex xs12 md7 lg8>
						  <v-card class="mb-3">
							<v-img height="200" src="https://t3.ftcdn.net/jpg/02/28/15/94/240_F_228159438_ws17802otLr1ZG9SK2ga7ducWtwrt2tg.jpg">
							  <v-container fill-height fluid pa-2>
								<v-layout fill-height>
								  <v-flex xs12 >
									<span class="headline white--text ml-3" v-text="telegramName"></span>
								  </v-flex>
								</v-layout>
							  </v-container>
							</v-img>
						  </v-card>								
	                    <v-card>
							<v-card-text>
								<template v-for="(item, index) in telegramGroupList">
									<div class="mt-3 mb-3 ml-3 mr-3" :key="index">
										<v-avatar color="primary" size="40" class="pointer" @click="viewUserTelegramInfo(item.userName)">
											 <img v-if="item.photoUrl" :src="item.photoUrl"/>
											 <span v-else class=" white--text headline">
											 	<span v-show="item.firstName != null">{{ item.firstName != null ? item.firstName.trim().substring(0, 1) : ''}}</span>
											 	<span v-show="item.firstName == null && item.lastName != null">{{ item.lastName != null ? item.lastName.trim().substring(0, 1) : ''}}</span>
												<span v-show="item.firstName == null && item.lastName == null && item.userName != null">{{ item.userName != null ? item.userName.trim().substring(0, 1) : ''}}</span>
											 </span>
										</v-avatar>
										<span class="ml-3  pointer hover-color" @click="viewUserTelegramInfo(item.userName)">
											<span v-if="item.firstName!=null" class="fw-bold font-lg">
												{{item.firstName!= null ? item.firstName : ''}} {{item.lastName!= null ? item.lastName : ''}}
											</span>
											<span v-else>
												{{item.userName != null ? item.userName : ''}}
											</span>
										</span>
										<span class="ml-3 fw-bold font-14">
											<v-icon size="18">schedule</v-icon>  
											{{dateFormat(parseInt(item.date*1000))}}
										</span>
										<div class="mt-3 ml-5 pl-2 font-md fw-400 overflow-hidden" >
											{{item.text}}
										</div>
									</div>
								</template>
							</v-card-text>
								<!--infinite-loading这个组件要放在列表的底部，滚动的盒子里面！-->
							<keep-alive>
							    <infinite-loading ref="infiniteLoading" :identifier="changeDate"   @infinite="findTelegramUserMsg" class="mb-3">
							        <div slot="spinner">
							            <v-progress-circular indeterminate color="primary"></v-progress-circular>
							        </div>
							        <div slot="no-more">noMore</div>
							        <div slot="no-results">noResults</div>
							    </infinite-loading>
							</keep-alive>
	                    </v-card>
						</v-flex>
						<v-flex xs12 md1 lg4>
								<app-right></app-right>
						</v-flex>
					</v-layout>
					</v-flex>
				</v-layout>
			</v-container>
		</div>
</div>
</template>

<script>
	 import config from '../../config.js'
	 import { mapGetters } from 'vuex'
	import InfiniteLoading from 'vue-infinite-loading';
	export default {
		data() {
			return {
				telegramName:'IOB Telegram',
				changeDate:+new Date(),
				telegramGroupList:[],
				PageNo:0,
				pageSize: 30,                           // 每次查询几条数据
			};
		},
		computed: {
			...mapGetters(["user"])
    },
	 components: {
	    InfiniteLoading,
	},
		mounted:function(){
		},
		 watch: {
			 /*监听*/
			 $route(){
				 this.chatId = this.$route.params.chatId;
			 },
			 chatId() {
				 if (this.chatId != null) {
				   //查询数据
				   /* 监听值有变化时将集合页码清空*/
				   this.telegramGroupList=[];
				   this.PageNo=0;
				   this.changeDate=this.changeDate+1;
				 }
			 },
		},
		   methods: {
				findTelegramUserMsg($state){
						  let url = config.baseUrl + "/telegramUser/open/telegramChat?pageNo="+this.PageNo+'&pageSize='+this.pageSize;
					this.$http.get(url).then(response => {
						if (response.data.resCode == 0) {
							  this.PageNo += 1;
							  this.telegramGroupList = [...this.telegramGroupList, ...response.data.result.telegramGroupList];
						   $state.loaded(); 
						} else {
						  $state.complete();
						}
					});
				},
				viewUserTelegramInfo(username){
					if (username) {
						window.open('https://telegram.me/' + username, '_blank');
					} else {
						alert("The user did not set a username.")
					}
				},
				// 格式化时间
				dateFormat(time) {
			      let timeOffset = -28800000;
			      if (this.user) {
			        timeOffset = this.user.timeOffset;
			      }
			      return formatDate(time, timeOffset, this.$i18n.locale);
			    },
        }
	}
</script>

<style>
.v-list__tile__title, .v-list__tile__sub-title{
	overflow: initial;
	z-index: 0;
}
.ivu-select-dropdown{
	position: absolute !important;
	z-index:1 !important;
}
.error-text{
	color: #ed4014;
}
.success-text{
	color: #41B8BC;
}
</style>



// WEBPACK FOOTER //
// TelegramUserMessages.vue?12573108